import { ResponseBlockMultipleChoice } from './ResponseBlockMultipleChoice.js';
import { ResponseBlockMathInline } from './ResponseBlockMathInline.js';
import { ResponseBlock } from './ResponseBlock.js';
import { ResponseBlockECR } from './ResponseBlockECR.js';
import { ResponseBlockMultiItem } from './ResponseBlockMultiItem.js';

export default {
  ResponseBlock,
  ResponseBlockMathInline,
  ResponseBlockMultipleChoice,
  ResponseBlockECR,
  ResponseBlockMultiItem,
};
